// ── Favorites — "Notify me when this user posts" ────────────────
// Purely client-side feature. Stores a list of pubkeys the user
// wants to get notified about when they post.
// Stored in localStorage, keyed per-user so multiple Nostr logins
// on the same browser don't bleed into each other.

const FAVORITES_KEY = 'bchnostr:favorites';

function getStorageKey(myPubkey?: string): string {
  return myPubkey ? `${FAVORITES_KEY}:${myPubkey}` : FAVORITES_KEY;
}

export function getFavorites(myPubkey?: string): string[] {
  try {
    const raw = localStorage.getItem(getStorageKey(myPubkey));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
}

export function isFavorite(targetPubkey: string, myPubkey?: string): boolean {
  return getFavorites(myPubkey).includes(targetPubkey);
}

export function addFavorite(targetPubkey: string, myPubkey?: string) {
  try {
    const list = getFavorites(myPubkey);
    if (list.includes(targetPubkey)) return;
    list.push(targetPubkey);
    localStorage.setItem(getStorageKey(myPubkey), JSON.stringify(list));
    // Dispatch event so other components can react
    window.dispatchEvent(new CustomEvent('bchnostr:favorites-changed'));
  } catch {}
}

export function removeFavorite(targetPubkey: string, myPubkey?: string) {
  try {
    const list = getFavorites(myPubkey).filter(pk => pk !== targetPubkey);
    localStorage.setItem(getStorageKey(myPubkey), JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('bchnostr:favorites-changed'));
  } catch {}
}

export function toggleFavorite(targetPubkey: string, myPubkey?: string): boolean {
  if (isFavorite(targetPubkey, myPubkey)) {
    removeFavorite(targetPubkey, myPubkey);
    return false;
  } else {
    addFavorite(targetPubkey, myPubkey);
    return true;
  }
}

